import useGoogleAnalytics from './useGoogleAnalytics';
import { sendEvent, sendPageview } from './googleAnalytics';

export { sendEvent, sendPageview };
export default useGoogleAnalytics;
